import { enumToStaticValue } from '@/utils'
import { PermissionType } from './permissionType'

export default enumToStaticValue(PermissionType, 'permission-type')
